<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div>
          <template>
            <v-card>
              <v-dialog persistent v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on }">
                  <div class="d-flex">
                    <v-btn color="#00004d" dark class="ml-auto ma-3 mr-1" @click="refreshData">
                      <i style="color: #fff" class="flaticon2-refresh-1"></i>
                    </v-btn>
                    <v-btn v-if="hasPermission('vendors.create')" color="#00004d" dark class="ma-3 ml-0" v-on="on">
                      Add
                      <v-icon class="ml-2" small>fas fa-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </template>
                <v-card>
                  <i class="fas fa-times custom-times" @click="closeDialog"></i>
                  <v-card-title>
                    <span v-if="editedItem.id">Edit {{ editedItem.name }}</span>
                    <span v-else>Create Developer</span>
                  </v-card-title>
                  <v-card-text>
                    <v-form
                        ref="form"
                        v-model="validationRules.valid"
                        lazy-validation
                    >
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-autocomplete
                              v-model="editedItem.contact_id"
                              :items="developersFilter"
                              item-text="full_name"
                              item-value="id"
                              clearable
                              outlined
                              required
                              :rules="validationRules.selectRule"
                              dense
                              deletable-chips
                              chips
                              :loading="isDevelopersLoaded"
                              small-chips
                              label="Developer* (min. 3 characters required)"
                              @keyup="developersFilterKeyUp"
                          >
                            <template v-slot:append-outer>
                              <a target="_blank" href="/contacts-management/contacts?addModule=true">
                                <v-icon>mdi-plus-circle-outline</v-icon>
                              </a>
                            </template>
                            <template v-slot:item="data">
                              <template v-if="typeof data.item !== 'object'">
                                <v-list-item-content v-text="data.item"></v-list-item-content>
                              </template>
                              <template v-else>
                                <v-list-item-content>
                                  <v-list-item-title>
                                          <h6>
                                            <span>{{ data.item.full_name }}</span>
                                            <v-chip
                                                v-if="Number(data.item.is_verified) === 1"
                                                x-small
                                                color="success"
                                                class="ml-1"
                                                dark
                                            >Verified</v-chip>
                                          </h6>
                                          <p v-if="data.item.uid">ID: {{ String(data.item.uid).toUpperCase() }}</p>
                                    <p>Phone(s):- {{ data.item.contact_phone_titles }}</p>
                                    <p>Email(s):- {{ data.item.contact_email_titles }}</p>
                                    <p>Role(s):- {{ data.item.contact_role_titles }}</p>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </template>
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.name"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="50"
                                        :counter="50" :rules="validationRules.nameRules"
                                        label="Name*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.admin_name"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="50"
                                        :counter="50" :rules="validationRules.nameRules"
                                        label="Admin Name*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.email"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="30"
                                        :counter="30" :rules="validationRules.emailRules"
                                        label="Email*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.number"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="20"
                                        :counter="20" :rules="validationRules.phoneRules"
                                        label="Mobile Number*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.telephone"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="20"
                                        :counter="20" :rules="validationRules.phoneRules"
                                        label="Telephone Number*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.developer_registration_number"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="20"
                                        :counter="20" :rules="validationRules.phoneRules"
                                        label="Developer Registration Number*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.pobox"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="20"
                                        :counter="20" :rules="validationRules.phoneRules"
                                        label="P.O. Box*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.website"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="100"
                                        :counter="100" :rules="validationRules.webRules"
                                        label="Website*" required></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.address"
                                        clearable
                                        outlined
                                        dense
                                        maxLength="200"
                                        :counter="200" :rules="validationRules.addressRules"
                                        label="Address*" required></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12">
                          <v-text-field v-model="editedItem.password" :counter="20"
                                        clearable
                                        outlined
                                        dense
                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="show ? 'text' : 'password'"
                                        @click:append="show = !show" label="Password"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDialog">Cancel</v-btn>
                    <v-btn :disabled="!validationRules.valid" color="blue darken-1" text @click="saveItem(editedItem)">
                      Save
                    </v-btn>
                  </v-card-actions>
                  <v-col cols="12">
                    <div v-if="errors!=undefined && errors.length >= 0"
                         role="alert"
                         v-bind:class="{ show: errors.length }"
                         class="alert fade alert-danger"
                    >
                      <div class="alert-text" v-for="(error, i) in errors" :key="i">
                        {{ error }}
                      </div>
                    </div>
                  </v-col>
                </v-card>
              </v-dialog>
              <hr style="margin:0"/>
              <v-card-title>
                Developers ({{ addTSBVZ(totalRecords) }})
                <v-spacer></v-spacer>
                <v-text-field
                    @keydown.enter="searchQueryData"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
              </v-card-title>
              <v-skeleton-loader :loading="loading" v-if="isLoaded" type="table"
              >
              </v-skeleton-loader>
              <v-data-table
                  :headers="headers"
                  :items="items"
                  :options.sync="pagination"
                  :server-items-length="totalRecords"
                  :footer-props="{
                    itemsPerPageOptions: rowsPerPageItems,
                    showFirstLastPage: true,
                  }"
                  :loading="loading"
                  v-show="!isLoaded"
                  mobile-breakpoint="100"
                  class="elevation-0">
                <template v-slot:item.name="{ item }">
                  <div class="text-truncate">
                    <p>{{ item.name }}</p>
                  </div>
                </template>
                <template v-slot:item.email="{ item }">
                  <div class="text-truncate">
                    <p>{{ item.email }}</p>
                  </div>
                </template>
                <template v-slot:item.created_at="{ item }">
                  <div class="text-truncate">
                    {{ formatDateAndTime(item.created_at) }}
                  </div>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="text-truncate">
                    <v-btn v-if="hasPermission('users.update')" color="#00004d" @click="showEditDialog(item)"
                           dark class="mr-2">
                      Edit
                      <v-icon dark right small>fas fa-edit</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
              <!-- this dialog is used for both create and update -->
            </v-card>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {
  USERS_LIST,
  CREATE_DEVELOPER,
  UPDATE_DEVELOPER,
  CLEAR_USER_ERRORS,
  DELETE_USER, GET_DEVELOPER_DETAILS,
} from "@/core/services/store/users.module";
import {SET_CONFIRMATION} from "@/core/services/store/confirmation.module";
import {CONTACTS_SIMPLE_LIST} from "@/core/services/store/contacts.module";
export default {
  name: 'developersUsers',
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name', name: 'name', filterable: true, sortable: true},
        {text: 'Email', value: 'email', name: 'email', filterable: true, sortable: true},
        {text: 'Contact', value: 'contact.full_name', name: 'contact', filterable: false, sortable: false},
        {text: "Created", value: "created_at", name: "created_at", filterable: true, sortable: true},
        {text: 'Actions', value: 'actions', name: 'actions', filterable: false, sortable: false},
      ],
      isLoaded: true,
      draw: 1,
      searchQuery: "",
      loading: true,
      developersFilter: [],
      isDevelopersLoaded: false,
      pagination: {
        page: 1,
        rowsPerPage: 25,
        totalItems: 0,
        sortDesc: "desc"
      },
      totalRecords: 0,
      rowsPerPageItems: [25, 50, 100, 150, 200],
      headerindex: "",
      columns: [],
      validationRules: {
        valid: true,
        selectRule: [
          (v) => {
            if (!v || v.length < 1)
              return 'Select an option';
            else return true;
          }
        ],
        nameRules: [
          v => !!v || "Name is required",
          v => (v && v.length >= 3) || "Name must be greater than or equal to 3 characters",
          v => (v && v.length <= 50) || "Name must be less than or equal to 50 characters"
        ],
        emailRules: [
          v => !!v || "Email is required",
          v => (v && v.length <= 30) || "Must be less than or equal to 30 characters",
          v => /.+@.+\..+/.test(v) || "Email must be valid"
        ],
        phoneRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 20) || "Must be less than or equal to 20 characters"
        ],
        webRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 100) || "Must be less than or equal to 100 characters"
        ],
        addressRules: [
          v => !!v || "This field is required",
          v => (v && v.length >= 3) || "Must be greater than or equal to 3 characters",
          v => (v && v.length <= 200) || "Must be less than or equal to 200 characters"
        ],
      },
      items: [],
      dialog: false,
      editedItem: {},
      show: false,
    }
  },
  watch: {
    params: {
      handler() {
        this.loadData().then(response => {
          this.items = response.items;
          this.totalRecords = response.total;
        });
      },
      deep: true
    },
    dialog(val) {
      !val && this.$store.dispatch(CLEAR_USER_ERRORS);
      if (!val) this.editedItem = {};
    }
  },
  mounted() {
    for (var i = 0; i < this.headers.length; i++) {
      this.columns.push(
          '&columns[' + i + '][data]=' + this.headers[i].value +
          '&columns[' + i + '][name]=' + this.headers[i].name +
          '&columns[' + i + '][searchable]=' + this.headers[i].filterable +
          '&columns[' + i + '][orderable]=' + this.headers[i].sortable +
          '&columns[' + i + '][search][value]=' +
          '&columns[' + i + '][search][regex]=' + false
      );
    }
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Contact's Management", route: "vendors"},
      {title: "Vendors"}
    ]);
    if (this.$route.query.hasOwnProperty('addModule')) {
      this.dialog = true;
    }
  },
  methods: {
    refreshData() {
      this.loadData().then(response => {
        this.items = response.items;
        this.totalRecords = response.total;
      });
    },
    searchQueryData: function (e) {
      if (e.keyCode === 13) {
        this.searchQuery = e.target.value;
      }
    },
    getHeaderIndex(name) {
      let that = this;
      this.headers.filter(function (ele, i) {
        if (name == ele.name) {
          that.headerindex = i;
        }
      });
    },
    loadData() {
      this.loading = true;
      this.isLoaded = true;
      return new Promise((resolve) => {
        let params = this.params;
        params.length = params.itemsPerPage; //set how many records to fetch per page
        params.start =
            params.page == 1 ? 0 : params.itemsPerPage * (params.page - 1); //set offset
        params.draw = this.draw;
        let query = Object.keys(params).map((key) => {
          return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
        }).join('&');
        this.getHeaderIndex(params.sortBy[0]);
        query +=
            "&type=2" +
            "&search[value]=" +
            params.query +
            "&search[regex]=" +
            false +
            "&order[0][column]=" +
            (params.sortBy.length === 0 ? 3 : this.headerindex) +
            "&order[0][dir]=" +
            (params.sortDesc[0] ? "desc" : "asc");
        this.$store.dispatch(USERS_LIST, {q: query, columns: this.columns}).then((res) => {
          this.draw++;
          let items = res.records.data;
          let total = res.records.recordsFiltered;
          this.loading = !this.loading;
          this.isLoaded = !this.isLoaded;
          resolve({
            items,
            total
          });
        });
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    showEditDialog(item) {
      this.$store.dispatch(GET_DEVELOPER_DETAILS, item.id).then((data) => {
        let conArr = []
        this.editedItem = data.records || {};
        if (data.records.contact) {
          conArr.push(data.records.contact)
          this.developersFilter = conArr;
        }
        this.dialog = !this.dialog;
      });
    },
    closeDialog() {
      this.dialog = !this.dialog;
    },
    saveItem(item) {
      if (this.$refs.form.validate()) {
        let method = CREATE_DEVELOPER;
        let id = item.id;
        let data = {
          data: item
        };
        if (id) {
          method = UPDATE_DEVELOPER;
          // delete data.data.id;
        }
        this.$store.dispatch(CLEAR_USER_ERRORS);
        this.$store.dispatch(method, {'slug': id, data: data.data}).then(() => {
          this.loadData().then(response => {
            this.items = response.items;
            this.totalRecords = response.total;
          });
          this.editedItem = {}
          this.dialog = !this.dialog
          if (this.$route.query.hasOwnProperty('addModule')) {
            window.close();
          }
        })
      }
    },
    deleteItem(item) {
      let that = this;
      this.$store.dispatch(SET_CONFIRMATION, {
        title: "Are you sure?", msg: "You want to delete '" + item.title + "'?", clr: 'red', callback: function () {
          let id = item.id;
          this.$store.dispatch(DELETE_USER, {
            'id': id
          }).then(() => {
            that.loadData().then(response => {
              that.items = response.items;
              that.totalRecords = response.total;
            });
          });
        }
      });
    },
    developersFilterKeyUp(e) {
      clearTimeout(this.apiTimeout)
      let that = this
      this.apiTimeout = setTimeout(function () {
        if (e.target.value.length >= 3) {
          that.isDevelopersLoaded = true;
          that.$store
              .dispatch(CONTACTS_SIMPLE_LIST, {
                role: 'Developers',
                q: e.target.value
              })
              .then(data => {
                that.developersFilter = that.developersFilter.concat(data.records.contactsList);
                that.isDevelopersLoaded = false;
              });
        }
      }, 900);
    },
  },
  computed: {
    params() {
      return {
        ...this.pagination,
        query: this.searchQuery
      };
    },
    ...mapState({
      errors: state => state.users.errors
    })
  }
};
</script>